import './BlockButton.css';
import $ from 'jquery';

function BlockButton(props) {

    const disabled = props.disabled
    const onClick = props.onClick

    const handleClick = (e) => {
        if (!disabled && onClick) {
          onClick(e);
        }
      };

    const test = (e) => {
        let borderColor = $(e.target).css("borderColor")
        console.log(disabled)
        if(!disabled) {
            if(borderColor === "rgb(0, 0, 0)") {
                $(e.target).css("backgroundColor", "black");
                $(e.target).css("color", "white");
                $(e.target).css("borderColor", "black")
            } else {
                $(e.target).css("backgroundColor", "grey");
                $(e.target).css("color", "white");
                $(e.target).css("borderColor", "white")
            }
        }
      }
    
      const buttonMouseLeave = (e) => {
        let borderColor = $(e.target).css("borderColor")
        if(!disabled) {
            if(borderColor === "rgb(0, 0, 0)") {
                $(e.target).css("backgroundColor", "white");
                $(e.target).css("color", "black");
                $(e.target).css("borderColor", "black")
            // $(e.target).css("filter", "none")
            } else {
                $(e.target).css("backgroundColor", "#2a2829");
                $(e.target).css("color", "white");
                $(e.target).css("borderColor", "white")
            // $(e.target).css("filter", "none")
            }
        }
      }  

  return ( 
      <div 
        disabled 
        className={`BlockButton ${props.disabled ? 'disabled' : ''}`} 
        onClick={handleClick} 
        onMouseEnter={(e) => test(e)} 
        onMouseLeave={(e) => buttonMouseLeave(e)} 
        style={{ width: props.width }} 
        >
        {props.children}
      </div>
  );
}

export default BlockButton;
